import React from 'react'
import { Outlet, Navigate } from 'react-router-dom';

const Privaterouter = () => {

    const isLogin = (localStorage.getItem('token'));
    return isLogin ? <Outlet /> : <Navigate to={'/'} />

}

export default Privaterouter